const signaturesFilterChange = (data = [], action) => {
    switch(action.type){
        case 'SIGNATURES_FILTER_REDUCER':
            data = action.data
            return  data;
        default:
            return data;
    }
}

export default signaturesFilterChange;